import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Container } from "../../../atoms/Container";
import BreadCrumbBar from "../../../atoms/BreadCrumbBar";
import urlPatterns from "../../../../urls";
import { GUIDES_TAB_BAR_SLUG } from "../../../../helpers/constants";
import GuidesDetail from "../GuidesDetail";
import { Section } from "../../../atoms/Section";
import { checkScrollingDown } from "../../../../helpers/tools";

class GuidesDetailMain extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showHeaderBarFromChild: true,
    };
    this.previousScrollY = 0;
  }

  componentDidMount() {
    return window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    return window.removeEventListener("scroll", this.handleScroll);
  }

  /**
   * Handler for scroll event listeners,
   * ...to set state to show or hide Header bar.
   * */
  handleScroll = () => {
    const { isScrollingDown, yValue } = checkScrollingDown(this.previousScrollY);
    this.previousScrollY = yValue;
    const { showHeaderBarFromChild } = this.state;
    if (showHeaderBarFromChild === isScrollingDown) {
      // CASE: If scrolling down, hides header if shown
      // and, if scrolling up, shows header if hidden.
      this.setState({ showHeaderBarFromChild: !isScrollingDown });
    }
  };

  /**
   * This returns the URL for the breadcrumb navigation bar when glossary pages are to be shown.
   *
   * @param {Object} tag
   * */
  getChildUrl = (tag) => {
    const { isFromTabGrape, isFromTabMore, isFromTabAll, isFromTabRegion, isFromTabTasting } = this.props;
    if (isFromTabAll) {
      return urlPatterns.GUIDE_101_GLOSSARY(tag.slug || GUIDES_TAB_BAR_SLUG.WINE_101_GUIDES);
    }
    if (isFromTabGrape) {
      return urlPatterns.GUIDE_GRAPE_COLOR_GLOSSARY(tag.slug || GUIDES_TAB_BAR_SLUG.GUIDE_GRAPE_COLOR);
    }
    if (isFromTabRegion) {
      return urlPatterns.GUIDE_REGION_GLOSSARY(tag.slug || GUIDES_TAB_BAR_SLUG.GUIDE_REGION);
    }
    if (isFromTabTasting) {
      return urlPatterns.GUIDE_TASTING_GLOSSARY(tag.slug || GUIDES_TAB_BAR_SLUG.GUIDE_TASTING);
    }
    if (isFromTabMore) {
      return urlPatterns.GUIDE_MORE_GLOSSARY(tag.slug || GUIDES_TAB_BAR_SLUG.GUIDE_MORE);
    }
    return null;
  };

  /**
   * If parent tag is the same as home slug, then only show 3 breadcrumbs.
   *
   * @param {Object} tag
   * @param {Boolean}
   * */
  checkIfThreeLayerBreadCrumb = (tag) => {
    const { isFromTabGrape, isFromTabMore, isFromTabAll, isFromTabRegion, isFromTabTasting } = this.props;
    if (isFromTabAll) {
      return tag?.slug === GUIDES_TAB_BAR_SLUG.WINE_101_GUIDES;
    }
    if (isFromTabGrape) {
      return tag?.slug === GUIDES_TAB_BAR_SLUG.GUIDE_GRAPE_COLOR;
    }
    if (isFromTabTasting) {
      return tag?.slug === GUIDES_TAB_BAR_SLUG.GUIDE_TASTING;
    }
    if (isFromTabRegion) {
      return tag?.slug === GUIDES_TAB_BAR_SLUG.GUIDE_REGION;
    }
    if (isFromTabMore) {
      return tag?.slug === GUIDES_TAB_BAR_SLUG.GUIDE_MORE;
    }
    return true;
  };

  render() {
    const { post, parentLabel, parentUrl, location } = this.props;

    const { showHeaderBarFromChild } = this.state;

    const { tags } = post || {};
    const [tag] = tags || [];

    const isThreeLayerBreadCrumb = this.checkIfThreeLayerBreadCrumb(tag);

    return (
      <Section xxs>
        {isThreeLayerBreadCrumb ? (
          <BreadCrumbBar
            homeLabel="Guides"
            parentLabel={parentLabel}
            parentUrl={parentUrl}
            childLabel={post.title || null}
            hideSearchField
            location={location}
          />
        ) : (
          <BreadCrumbBar
            homeLabel="Guides"
            parentLabel={parentLabel}
            parentUrl={parentUrl}
            childLabel={tag && tag.name}
            childUrl={this.getChildUrl(tag)}
            grandChildLabel={post.title || null}
            hideSearchField
            location={location}
          />
        )}
        <Container>
          <GuidesDetail post={post} isHeaderShown={showHeaderBarFromChild} location={location} />
        </Container>
      </Section>
    );
  }
}

GuidesDetailMain.propTypes = {
  post: PropTypes.shape({}).isRequired,
  parentLabel: PropTypes.string.isRequired,
  parentUrl: PropTypes.string.isRequired,
  isFromTabGrape: PropTypes.bool,
  isFromTabMore: PropTypes.bool,
  isFromTabAll: PropTypes.bool,
  isFromTabRegion: PropTypes.bool,
  isFromTabTasting: PropTypes.bool,
  location: PropTypes.shape({}).isRequired,
};

GuidesDetailMain.defaultProps = {
  isFromTabGrape: false,
  isFromTabMore: false,
  isFromTabAll: false,
  isFromTabRegion: false,
  isFromTabTasting: false,
};

export default GuidesDetailMain;
